<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="3">
	    <v-select
          v-model="periodScope"
          :items="periodScopes"
          :item-text="periodScopes.text"
          return-object
          label="Select"
          hide-details
          prepend-icon="mdi-clock"
          single-line
        ></v-select>

        <!-- Data Picker -->
        <!-- <v-menu 
            v-model="vMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
            >
            
            <v-text-field
                :label="input.label"
                :value="itemLoaded[input.objectParent][input.vModel] | datePlusWeek"
                slot="activator"
                clearable
                prepend-icon="event"
                readonly
                :required="input.required"
                :disabled="mode === 'remove' || mode === 'view' || input.disabled"
                :mask="input.mask"
            >
            </v-text-field>
            <v-date-picker
                locale="pt-br"
                v-model="itemLoaded[input.vModel]"
                @change="vMenu[index] = false"
                :disabled="mode === 'remove' || mode === 'view' || input.disabled"
            >
            </v-date-picker>
        </v-menu> -->


      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('registers')

export default {
    name: 'Filters',
    props: [],
    data: () => ({
        vMenu: false,
        
    }),
    computed: {
        ...mapGetters(['periodScopes']),
        
		periodScope: {
			get () {
				return this.$store.state.registers.periodScope
			},
			set (value) {
				this.$store.commit('registers/setPeriodScope', value)
			}
			},
    },
    
}
</script>

<style>
 
</style>